import { Box, Button, Grid, TextField } from '@deere/fuel-react';
import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { EmployeeInfo } from './EmployeeInfo';
import styles from './Reports.module.css';

export const Reports = () => {
    const navigate = useNavigate();
    const { racf } = useParams();
    const [searchValue, setSearchValue] = useState(racf ?? '');

    const handleSearch = (event) => {
        event?.preventDefault();
        const trimmed = searchValue.trim();
        if (!trimmed) {
            return;
        }
        navigate('/reports/' + trimmed);
    };

    return (
        <>
            <div className={styles.parentContainer}>
                <Box className={styles.contentToContainer}>
                    <form onSubmit={handleSearch} className={styles.searchForm}>
                        <Grid container spacing={2} alignItems="flex-end">
                            <Grid item xs={12} sm={8} md={6}>
                                <TextField
                                    id="racf-search"
                                    label="Employee RACF ID"
                                    type="text"
                                    placeholder="Enter RACF ID"
                                    value={searchValue}
                                    onChange={(e) =>
                                        setSearchValue(e.target.value)
                                    }
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={2}>
                                <Button
                                    type="submit"
                                    variant="primary"
                                    onClick={handleSearch}
                                    disabled={!searchValue.trim()}
                                >
                                    Search
                                </Button>
                            </Grid>
                        </Grid>
                    </form>
                </Box>
            </div>
            {racf && <EmployeeInfo />}
        </>
    );
};
